import { DirectoryAttributeDirectionConsts, DirectoryTypeKeys } from 'client/util/Constants';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import createDirectoryCollection from 'client/store/modules/models/createDirectoryCollection';

const exportAttr = DirectoryAttributeDirectionConsts.export.value;
const excludeAttr = DirectoryAttributeDirectionConsts.exclude.value;

/**
 * The frozen attributes are always exported to Microsoft 365 and cannot be
 * disabled. All other attributes can be enabled or disabled for export from
 * JumpCloud to Microsoft 365.
 */
export const getDefaultExportAttributes = () => ({
  firstname: Object.freeze({
    key: 'firstname',
    direction: exportAttr,
    attrNames: {
      jc: 'firstname',
      directory: 'givenName',
    },
    id: null,
    name: 'First Name',
    value: true,
  }),
  lastname: Object.freeze({
    key: 'lastname',
    direction: exportAttr,
    attrNames: {
      jc: 'lastname',
      directory: 'surname',
    },
    id: null,
    name: 'Last Name',
    value: true,
  }),
  password: Object.freeze({
    key: 'password',
    direction: exportAttr,
    attrNames: {
      jc: 'password',
      directory: 'password',
    },
    id: null,
    name: 'Password',
    value: true,
  }),
  user_principal_name_from_alternate_email: {
    key: 'user_principal_name_from_alternate_email',
    direction: exportAttr,
    attrNames: {
      jc: 'email',
      directory: 'userPrincipalName',
    },
    id: null,
    name: 'Company Email',
    value: false,
  },
  email: Object.freeze({
    key: 'email',
    direction: exportAttr,
    attrNames: {
      jc: 'email',
      directory: 'userPrincipalName',
    },
    id: null,
    name: 'Company Email',
    value: true,
  }),
  user_business_phones: {
    key: 'user_business_phones',
    direction: excludeAttr,
    attrNames: {
      jc: 'phoneNumbers.work.number',
      directory: 'businessPhone',
    },
    id: null,
    name: 'Work Phone',
    value: false,
  },
  user_alternate_email: {
    key: 'user_alternate_email',
    direction: excludeAttr,
    attrNames: {
      jc: 'alternateEmail',
      directory: 'otherEmails',
    },
    id: null,
    name: 'Alternate Email',
    value: false,
  },
  user_city: {
    key: 'user_city',
    direction: excludeAttr,
    attrNames: {
      jc: 'addresses.work.locality',
      directory: 'city',
    },
    id: null,
    name: 'Work City',
    value: false,
  },
  user_country: {
    key: 'user_country',
    direction: excludeAttr,
    attrNames: {
      jc: 'addresses.work.country',
      directory: 'country',
    },
    id: null,
    name: 'Work Country',
    value: false,
  },
  user_department: {
    key: 'user_department',
    direction: excludeAttr,
    attrNames: {
      jc: 'department',
      directory: 'department',
    },
    id: null,
    name: 'Department',
    value: false,
  },
  user_job_title: {
    key: 'user_job_title',
    direction: excludeAttr,
    attrNames: {
      jc: 'jobTitle',
      directory: 'jobTitle',
    },
    id: null,
    name: 'Title',
    value: false,
  },
  user_manager: {
    key: 'user_manager',
    direction: excludeAttr,
    attrNames: {
      jc: 'manager',
      directory: 'manager',
    },
    id: null,
    name: 'Manager',
    value: false,
  },
  user_mobile_phone: {
    key: 'user_mobile_phone',
    direction: excludeAttr,
    attrNames: {
      jc: 'phoneNumbers.mobile.number',
      directory: 'mobilePhone',
    },
    id: null,
    name: 'Personal Cell',
    value: false,
  },
  user_office_location: {
    key: 'user_office_location',
    direction: excludeAttr,
    attrNames: {
      jc: 'location',
      directory: 'officeLocation',
    },
    id: null,
    name: 'Work Location',
    value: false,
  },
  user_postal_code: {
    key: 'user_postal_code',
    direction: excludeAttr,
    attrNames: {
      jc: 'addresses.work.postalCode',
      directory: 'postalCode',
    },
    id: null,
    name: 'Work Postal Code',
    value: false,
  },
  user_state: {
    key: 'user_state',
    direction: excludeAttr,
    attrNames: {
      jc: 'addresses.work.region',
      directory: 'state',
    },
    id: null,
    name: 'Work State',
    value: false,
  },
  user_street_address: {
    key: 'user_street_address',
    direction: excludeAttr,
    attrNames: {
      jc: 'addresses.work.streetAddress',
      directory: 'streetAddress',
    },
    id: null,
    name: 'Work Street Address',
    value: false,
  },
});

export const exportAttributesKbUrl = KbArticleUrls.officeAttributes;

export default createDirectoryCollection(
  DirectoryTypeKeys.office365,
  getDefaultExportAttributes,
  exportAttributesKbUrl,
);
